import * as React from 'react';
import styled from 'styled-components';

import {BREAKPOINTS, COLORS, ComponentTextStyle} from '../../styles';
import FooterDropdownLinks from './FooterDropdownLinks';
import {NavOptions} from '../../types';
import {ComponentLStyling, ComponentSStyling} from '../../styles/typography';
import {HyperLink} from '../../HyperLink';
import { hasWindow } from '../../utils/utils';

const NavSection = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: flex-start;
  color: white;
  margin-bottom: 12px;
`;

const LinkBlock = styled.div<{ width: number }>`
  display: ${(props) => (props.width <= 768 ? 'none' : 'flex')};
  flex-direction: column;
  font-weight: normal;
  width: 100%;

  ${BREAKPOINTS.MEDIUM} {
    padding: 0 24px 24px 0;
    width: calc(50% - 24px);
  }

  ${BREAKPOINTS.LARGE} {
    width: calc(33% - 24px);
  }
  ${BREAKPOINTS.LARGE} {
    padding: 0 32px 32px 0;
    width: calc(33% - 32px);
  }

  h3 {
    ${ComponentLStyling(ComponentTextStyle.Regular, 'inherit')}
  }

  a {
    padding: 8px 0px;
    ${ComponentSStyling(ComponentTextStyle.Bold, COLORS.white)}
  }
`;

interface FooterNavSectionProps {
  navOptions: NavOptions;
  mainId: string;
}

const FooterNavSection = ({ navOptions }: FooterNavSectionProps) => {
  const [width, setWidth] = React.useState<number>(hasWindow() ? window.innerWidth : -1);
  React.useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <NavSection>
      {navOptions.sections?.map((no, index) => {
        return width > 768 ? (
          <LinkBlock key={`LinkBlock_${index}`} width={width}>
            <h3>{no.header}</h3>
            {no.links.map((link, index) => (
              <HyperLink key={index}
                         id={`dropdownlink_${Math.floor(Math.random() * 999999999999)}`}
                         variant={'inverted'}
                         href={link.to}
                         target={link.target || '_blank'}
                         rel="noreferrer noopener">
                {link.label}
              </HyperLink>
            ))}
          </LinkBlock>
        ) : (
          <FooterDropdownLinks data-testid={'footerDropLinks'} key={`LinkBlockDropdown_${index}`} navSection={no} width={width} />
        );
      })}
    </NavSection>
  );
};

export default FooterNavSection;
